var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "617eeb9f7b335339ae143510e7a00b14.png",
    width: 310,
    height: 600
});